import { render } from "./NoImage.vue?vue&type=template&id=7fd309d0&lang=pug"
import script from "./NoImage.vue?vue&type=script&lang=js"
export * from "./NoImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__